import request from "../request";

/**
 * Добавление в корзину для 2 планов
 * @return {Promise}
 */
export const addToCart = ({ eventId, sid }) => {
  return request({
    url: "/split-cart/add",
    data: {
      event_id: eventId,
      sid
    }
  });
};

export const removeFromCart = ({ eventId, sid }) => {
  return request({
    url: "/split-cart/remove",
    data: {
      event_id: eventId,
      sid
    }
  });
};

export const getViews = () => {
  return request({
    url: "/split/get-views",
    type: "GET"
  });
};

export const hasTicket = ({mainEventId, subEventId}) => {
  return request({
    url: `/split-cart/has-ticket?mainEventId=${mainEventId}&subEventId=${subEventId}`,
    type: "GET"
  });
};
